import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { IState, ISuccessAction, IFailureAction } from 'interfaces/update-duck';

const { Types, Creators } = createActions(
  {
    request: ['id', 'putData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'ALLOW_SHIP_PICKING_' }
);

export interface AllowShipPickingState extends IState {}

const INITIAL_STATE: AllowShipPickingState
 = {
  loading: false,
  error: null,
};

const request = (state: AllowShipPickingState
) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: AllowShipPickingState
, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: AllowShipPickingState
, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const allowShipPicking = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const AllowShipPickingTypes= Types;
export const AllowShipPickingActions = Creators;
